import icDown from 'assets/images/ic-chev-down.svg'
import icCloseSquare from 'assets/images/ic-close-square.svg'
import icFileDown from 'assets/images/ic-file-down-02.svg'
import icFileEdit01 from 'assets/images/ic-file-edit-02.svg'
import icFileUp from 'assets/images/ic-file-up-02.svg'
import icRefresh01 from 'assets/images/ic-refresh-01.svg'
import icRefreshPrimary from 'assets/images/ic-refresh-primary.svg'
import clsx from 'clsx'
import Button from 'components/commons/button'
import DeleteModal from 'components/commons/delete-modal'
import { ExportModal } from 'components/commons/ExportModal'
import Modal from 'components/commons/modal/Modal'
import Search from 'components/commons/search'
import { StandardModal } from 'components/commons/StandardModal'
import Table from 'components/commons/table'
import Toast from 'components/commons/toast'
import ViewList from 'components/commons/view-list'
import { TABLE_DEVELOPMENT_SUMMARY_DETAIL } from 'configs/hr-metrics/configTableDevelopmentSummary'
import { DevelopmentSummaryFilterContainer } from 'containers/hr-metrics/development-summary/DevelopmentSummaryFilterContainer'
import { FormDevelopmentSummaryContainer } from 'containers/hr-metrics/development-summary/FormDevelopmentSummaryContainer'
import { ImportDevelopmentSummaryContainer } from 'containers/hr-metrics/development-summary/ImportDevelopmentSummaryContainer'
import { UploadFileDevelopmentSummaryContainer } from 'containers/hr-metrics/development-summary/UploadFileDevelopmentSummaryContainer'
import { useClickOutside } from 'hooks/useClickOutside'
import { useState } from 'react'
import { onOpenFile } from 'utils/utils'

export const DevelopmentSummaryDetail = ({
    dataList,
    isLoading,
    isDeleting,
    isSyncing,
    query,
    queryFilter,
    toast,
    modal,
    selectedIds,
    setShowModal,
    optionUpload,
    fileType,
    selectedItem,
    setSelectedIds,
    clearToast,
    onChangeQuery,
    onClickItemHandler,
    onExportHandler,
    onDelete,
    onSync,
    onHideImport,
    onHideModal,
    onSelectUpload,
    onSuccess,
}) => {
    const elementID = 'dropdownUploadFile'
    const [showUploadFile, setShowUploadFile] = useState(false)
    useClickOutside({ callback: () => showUploadFile && setShowUploadFile(false), elementID })

    return (
        <>
            <div className={'flex justify-between px-6 py-4 gap-3'}>
                <div className={'flex gap-3'}>
                    <Search onSearch={(search) => onChangeQuery({ page: 1, search })} value={query?.search} />
                    <DevelopmentSummaryFilterContainer
                        queryFilter={queryFilter}
                        onSubmit={(queryFilter) => onChangeQuery({ ...queryFilter, page: 1 })}
                    />
                    <ViewList
                        show={modal?.limit}
                        onShow={() => setShowModal({ limit: true })}
                        onClose={() => setShowModal({ limit: false })}
                        value={query?.limit}
                        onSelectSize={(limit) => onChangeQuery({ page: 1, limit })}
                    />
                    <Button
                        title='Export'
                        icon={icFileUp}
                        type='outline'
                        onClick={() => setShowModal({ export: true })}
                    />
                    <Button
                        title='Import'
                        icon={icFileDown}
                        type='outline'
                        onClick={() => setShowModal({ import: true })}
                    />
                </div>
                <div className='flex gap-3'>
                    <div className='relative'>
                        <Button
                            title='Upload File'
                            type='outline'
                            icon={icFileEdit01}
                            iconAfter={icDown}
                            onClick={() => setShowUploadFile(!showUploadFile)}
                        />
                        <div
                            id={elementID}
                            className={clsx(
                                'absolute bg-white right-0 mt-1 p-1.5 border border-neutral-20 rounded-lg shadow-sm whitespace-nowrap transition-all duration-200 w-[180px] z-10',
                                showUploadFile ? 'opacity-100 visible' : 'opacity-0 collapse',
                            )}
                        >
                            {Object.entries(optionUpload).map(([key, value]) => (
                                <div
                                    key={key}
                                    className='hover:bg-primary-10 capitalize px-4 py-2.5 rounded-lg cursor-pointer transition-all duration-200'
                                    onClick={() => onSelectUpload(value)}
                                >
                                    {value.replace('_', ' ')}
                                </div>
                            ))}
                        </div>
                    </div>
                    <Button title='Sync Data' icon={icRefresh01} onClick={() => setShowModal({ sync: true })} />
                </div>
            </div>
            <Table
                className='my-3'
                name={TABLE_DEVELOPMENT_SUMMARY_DETAIL.name}
                columns={TABLE_DEVELOPMENT_SUMMARY_DETAIL.column}
                data={dataList?.results}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onChangePage={(val) => onChangeQuery({ page: val })}
                onClickSort={(val) => onChangeQuery(val)}
                onClickItem={onClickItemHandler}
                onSelectItem={setSelectedIds}
                loading={isLoading}
            />

            <ExportModal
                title='Apakah anda yakin ingin export data development summary ?'
                description={`Total data development summary export: ${selectedIds?.length || dataList?.total_result}`}
                show={modal.export}
                onExportHandler={onExportHandler}
                onCancelHandler={() => setShowModal({ export: false })}
            />

            <DeleteModal
                show={modal?.delete}
                onHide={() => setShowModal({ delete: false })}
                onDelete={onDelete}
                isLoading={isDeleting}
                text='Apakah anda yakin ingin menghapus data development summary ini ?'
            />

            <StandardModal
                show={modal?.sync}
                onHide={() => setShowModal({ sync: false })}
                text='Apakah anda yakin ingin sync data development summary ini ?'
                icon={icRefreshPrimary}
                onSubmit={onSync}
                isLoading={isSyncing}
                confirmText='Sync'
            />

            <UploadFileDevelopmentSummaryContainer
                fileType={fileType}
                show={modal?.upload}
                onHide={() => setShowModal({ upload: false })}
                onSuccess={() => onSuccess('Upload Data Berhasil !!')}
            />

            <FormDevelopmentSummaryContainer
                data={selectedItem}
                show={modal?.edit}
                onHide={() => onHideModal('edit')}
                onSuccess={() => onSuccess('Edit Data Berhasil !!')}
            />

            <Modal
                dialogClassName='max-w-xl'
                contentClassName='relative col max-h-[90%] rounded-lg overflow-auto'
                show={modal?.view_document}
                onHide={() => onHideModal('view_document')}
            >
                <div className={'px-6 py-3 flex flex-row items-center justify-between border-b'}>
                    <p className={'font-semibold text-md'}>Documents</p>
                    <Button
                        type='outline'
                        shape='circle'
                        size='small'
                        icon={icCloseSquare}
                        onClick={() => setShowModal({ view_document: false })}
                    />
                </div>
                <div className='flex flex-col gap-4 px-6 py-4'>
                    {Object?.entries(selectedItem || {})?.map(([key, value]) => (
                        <div key={key} className='flex gap-3'>
                            <p className='w-1/3 font-semibold capitalize text-primary-50 shrink-0'>
                                {key.replace('_', ' ')}
                            </p>
                            :
                            <div className='col font-semibold'>
                                {value ? (
                                    <div
                                        className='cursor-pointer underline flex-1 truncate [direction:rtl] w-[300px] text-left'
                                        onClick={() => onOpenFile({ urls: [value] })}
                                    >
                                        {value}
                                    </div>
                                ) : (
                                    '-'
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </Modal>

            <Toast show={toast?.isShowToast} message={toast?.message} onClose={() => clearToast()} />

            <ImportDevelopmentSummaryContainer show={modal?.import} onHide={onHideImport} />
        </>
    )
}
